var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#EA5E23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0369 9.96282C10.1957 10.1215 10.1957 10.3788 10.0369 10.5375C9.95786 10.6166 9.85387 10.6567 9.74987 10.6567C9.64586 10.6567 9.54187 10.6172 9.46278 10.5375L6.49986 7.57462L3.53695 10.5375C3.45786 10.6166 3.35386 10.6567 3.24986 10.6567C3.14586 10.6567 3.04186 10.6172 2.96278 10.5375C2.80407 10.3788 2.80407 10.1215 2.96278 9.96282L5.9257 6.99992L2.96278 4.03702C2.80407 3.87831 2.80407 3.621 2.96278 3.46229C3.12149 3.30358 3.37878 3.30358 3.53749 3.46229L6.50041 6.42523L9.46332 3.46229C9.62203 3.30358 9.87932 3.30358 10.038 3.46229C10.1967 3.621 10.1967 3.87831 10.038 4.03702L7.07511 6.99992L10.0369 9.96282Z",
    fill: "white",
    style: {
      transform: "translate(4px, 4px)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCross);
export default __webpack_public_path__ + "static/media/filter-cross.6a7d8e53f627a5c9da93090a3fe23cc4.svg";
export { ForwardRef as ReactComponent };